import React from 'react';
import {
    FaPython,
    FaReact,
    FaArrowRight,
    FaNodeJs,
    FaPhp,
    FaDesktop,
    FaDatabase,
    FaRobot,
    FaUikit,
} from 'react-icons/fa';

import MyArea from '../components/displayPage/about/myArea';
import MySkill from '../components/displayPage/about/mySkill';

const About = (prop) => {
    return (
        <div className="" id="about">
            <div className="w-full h-1 bg-teal-900  sm:-ml-5 mb-10"></div>
            {/* <p className="font-bold text-teal-900 pl-1 md:pl-5">About us</p> */}
            <p className="text-sm w-full md:w-5/6 mt-10 pl-2 sm:pl-5 lg:pl-10 leading-7">
                Hi, my name is Stephen Oluwasusi, I am software developer with
                experience in building websites for small, medium and large
                sized businesses. Whether you are trying to win work, list your
                services or even create a whole online store - I can help.
                <br />
                <br />
                I am experienced in REACT, REDUX-TOOLKIT, TAILWING, HTML, CSS,
                JAVASCRIPTS, JQUERY, NODE JS, MONGODB, SEQUELIZE, EXPRESS,
                AGREGGATE FRAMEWORK, PHP, MYSQL. I have also acquainted myself
                with a wide range of skills that allow me to blend with the
                group or team's culture and to continuously strive to reach
                common goals amidst failures and setbacks. <br />
                <br />
                In addiction, my active involvement in many academic and
                extracurricular activities has helped me tremendously in
                developing my communication and leadership skills which are
                vital in finding success in corperate world.
                <br />
                <br />
                Regular communication is really important to me, so let's keep
                in touch!.
            </p>

            <div className="flex w-full mt-16 flex justify-evenly flex-wrap">
                <MyArea
                    name="Frontend Development"
                    color="purple"
                    icon={<FaDesktop />}
                    aos="fade-right"
                    aos_delay="200"
                />
                <MyArea
                    name="Backend Development"
                    color="red"
                    icon={<FaDatabase />}
                    aos="fade-right"
                    aos_delay="50"
                />
                <MyArea
                    name="Artificial Intelligence"
                    color="blue"
                    icon={<FaRobot />}
                    aos="fade-left"
                    aos_delay="50"
                />
                <MyArea
                    name="Graphics Design"
                    color="purple"
                    icon={<FaUikit />}
                    aos="fade-left"
                    aos_delay="200"
                />
            </div>

            <div className="bg-teal-500 w-full py-5 mt-8 flex justify-between items-center px-2 md:px-6">
                <h2 className="font-bold pl-4 text-black">
                    SOME OF MY EXPERTISE
                </h2>
                <i className="border-2 p-3 border-black hover:border-white transition-all hover:text-white rounded mr-5 lg:mr-10">
                    <FaArrowRight />
                </i>
            </div>

            <div
                className="flex w-full mt-16 flex justify-evenly flex-wrap"
                id="skills"
            >
                <MySkill
                    name="React.js"
                    color="teal"
                    icon={<FaReact />}
                    aos="flip-up"
                    aos_delay="50"
                />
                <MySkill
                    name="Python"
                    color="purple"
                    icon={<FaPython />}
                    aos="fade-down"
                    aos_delay="200"
                />
                <MySkill
                    name="Node Js"
                    color="yellow"
                    icon={<FaNodeJs />}
                    aos="flip-up"
                    aos_delay="200"
                />
                <MySkill
                    name="PHP"
                    color="blue"
                    icon={<FaPhp />}
                    aos="fade-down"
                    aos_delay="50"
                />
            </div>

            <br />
            <br />
            <br />
            <br />
        </div>
    );
};

export default About;
